module["exports"] = [
  0
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nep/address/postcode.js
 ** module id = 860
 ** module chunks = 0
 **/